import styled from '@emotion/styled';
import { Micro } from '@travelnest/merlin.typography';
import React from 'react';
import { paletteV5, typographyV5 } from '../../components/property-score/PropertyScoreSummary';

const TitleWrapper = styled.div`
	display: inline-flex;
`;

const UnreadIndicator = styled.div`
	background-color: ${paletteV5.green.primary};
	height: 7px;
	width: 7px;
	border-radius: 100%;
	margin-left: 5px;
`;

interface ISegmentTitle {
	text: string;
	count: number;
	unread: boolean;
}
/*
color is set to inherit because the segmented control component has logic
to change the colour of the active tab
*/
export const SegmentTitle: React.FC<ISegmentTitle> = ({ text, count, unread }) => {
	return (
		<TitleWrapper>
			<Micro style={{ ...typographyV5.micro, color: 'inherit' }}>{text} {count > 0 && `(${count})`}</Micro>
			{unread && <UnreadIndicator />}
		</TitleWrapper>
	);
};
